import React, { useState } from 'react'
import CommonLayout from '../CommonLayout';
import PreviewPopupTable from './PreviewPopupTable';

const EditSuggestionRuleAction = ({prevData, newData}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [suggestionRuleData, setSuggestionRuleData] = useState({});

  // Format type_names array for display
  const formatTypeNames = (typeNames) => {
    if (!typeNames || !Array.isArray(typeNames) || typeNames.length === 0) {
      return "-";
    }
    return typeNames.join(", ");
  };

  // Format data for display
  const formatData = (data) => {
    if (!data) return data;
    const formatted = { ...data };
    formatted.type_names_show = formatTypeNames(formatted.type_names);
    return formatted;
  };

  const fieldsData = [
    { colKey: "rule_name", colText: "Suggestion" },
    { colKey: "type_names_show", colText: "Applicable Types" },
    { colKey: "criteria", colText: "Criteria" },
    { colKey: "criteria_format_text", colText: "Criteria Format" },
    { colKey: "match_count", colText: "Matches" },
  ];

  const prevFormatted = formatData(prevData);
  const newFormatted = formatData(newData);

  const showPopupHandler = (data) => {
    setSuggestionRuleData(data);
    setShowPopup(true);
  };

  return (
    <>
      <CommonLayout
        prevData={prevFormatted}
        newData={newFormatted}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHandler}
      />
      {showPopup && (
        <PreviewPopupTable
          suggestionRule={suggestionRuleData}
          hidePopup={() => setShowPopup(false)}
        />
      )}
    </>
  );
}

export default EditSuggestionRuleAction

